<!--@format-->
<template>
    <div class="journey-contact-update-step-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Contact Update</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="loading">
                    <loading-screen-svg />
                </div>
                <div v-else>
                    <div class="form-row">
                        <label>Type of Update *</label>
                        <journey-contact-update-type-dropdown
                            v-model="step.updateType"
                            :initialId="step.initialUpdateType"
                        />
                    </div>
                    <div v-if="clientId && step.updateType">
                        <div v-if="step.updateType.id === 'ContactStatus'" class="form-row">
                            <label>Change Status To *</label>
                            <contact-statuses-dropdown
                                v-model="step.updateValue"
                                :clientId="clientId"
                                :initialId="initialContactStatusId"
                            />
                        </div>
                        <div
                            v-if="
                                step.updateType.id === 'AddToList' ||
                                step.updateType.id === 'RemoveFromList'
                            "
                            class="form-row"
                        >
                            <label>List *</label>
                            <list-search
                                v-model="step.updateValue"
                                :clientId="clientId"
                                :initialId="initialListId"
                            />
                        </div>
                        <div v-if="step.updateType.id === 'AssignSalesRep'" class="form-row">
                            <label>Sales Rep *</label>
                            <user-assign-dropdown
                                v-model="step.updateValue"
                                :clientId="clientId"
                                :initialId="initialSalesRepId"
                                salespeopleOnly
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button :disabled="loading" :loading="loading" @click="save"
                        >Save</app-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
const JourneyContactUpdateTypeDropdown = () =>
    import('@/components/journey/journey-contact-update-type-dropdown');
const ContactStatusesDropdown = () => import('@/components/contact/contact-statuses-dropdown');
const UserAssignDropdown = () => import('@/components/user/user-assign-dropdown');
const ListSearch = () => import('@/components/list/list-search');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'journey-contact-update-step-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
        'journey-contact-update-type-dropdown': JourneyContactUpdateTypeDropdown,
        'contact-statuses-dropdown': ContactStatusesDropdown,
        'list-search': ListSearch,
        'user-assign-dropdown': UserAssignDropdown,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: true,

            clientId: null,

            step: {
                id: this.widget.stepId,
                initialUpdateType: null,
                initialUpdateValue: null,
                templateId: this.widget.journeyTemplateId,
                updateType: null,
                updateValue: null,
                list: null,
                assignedUser: null,
            },
        };
    },

    computed: {
        initialContactStatusId() {
            return this.step.initialUpdateType === 'ContactStatus'
                ? parseInt(this.step.initialUpdateValue)
                : null;
        },

        initialListId() {
            return this.step.initialUpdateType === 'AddToList' ||
                this.step.initialUpdateType === 'RemoveFromList'
                ? parseInt(this.step.initialUpdateValue)
                : null;
        },

        initialSalesRepId() {
            return this.step.initialUpdateType === 'AssignSalesRep'
                ? this.step.initialUpdateValue
                : null;
        },
    },

    watch: {
        'step.updateType'() {
            this.step.updateValue = null;
        },
    },

    created() {
        this.getStep();
    },

    methods: {
        save() {
            this.loading = true;
            this.patchStep();
        },

        patchStep() {
            var changes = [
                {
                    name: 'UpdateType',
                    value: this.step.updateType ? this.step.updateType.id : null,
                },
                {
                    name: 'UpdateValue',
                    value: this.step.updateValue ? this.step.updateValue.id : null,
                },
            ];

            this.$api
                .patch(`/api/JourneySteps/${this.step.id}`, changes)
                .then(() => {
                    this.$helpers.showSuccessNotification('Step successfully saved.');
                    EventBus.$emit(`journey-step:update`, this.step);
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your step.',
                        { error },
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getStep() {
            var expandParam = `$expand=Journey($select=ClientId),JourneyTemplate($select=ClientId)`;
            var filterParam = `$filter=Id eq ${this.step.id}`;
            var selectParam = `$select=UpdateType,UpdateValue,Journey`;
            var restUrl = `/service/JourneySteps?${expandParam}&${filterParam}&${selectParam}`;

            this.$api
                .get(restUrl)
                .then((response) => {
                    var responseValue = response.data.value[0];

                    this.clientId = responseValue.JourneyTemplate
                        ? responseValue.JourneyTemplate.ClientId
                        : responseValue.Journey.ClientId;

                    this.step.initialUpdateType = responseValue.UpdateType;
                    this.step.initialUpdateValue = responseValue.UpdateValue;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while fetching your step.',
                        { error },
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.journey-contact-update-step-widget.widget .widget-contents-container .widget-header {
    background: rgb(75, 201, 254) !important;
    background: linear-gradient(
        238deg,
        rgba(75, 201, 254, 1) 0%,
        rgba(80, 82, 254, 1) 100%
    ) !important;
}

.journey-contact-update-step-widget .content-wrapper {
    padding: 0px;
}

.journey-contact-update-step-widget .content-wrapper label {
    display: block;
    font: 500 16px/1em 'Roboto';
    margin-bottom: 7px;
}

.journey-contact-update-step-widget .content-wrapper .form-row {
    margin-bottom: 20px;
}

.journey-contact-update-step-widget .content-wrapper .input-fields {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.journey-contact-update-step-widget .content-wrapper .input-fields .app-input {
    margin-right: 20px;
}

.journey-contact-update-step-widget .due-date-row .input-fields > span {
    margin-left: 20px;
    width: 200px;
}

.journey-contact-update-step-widget.widget .app-text-editor .fr-box.fr-basic.fr-top .fr-wrapper {
    border: 1px solid #e9e9ef;
}

.journey-contact-update-step-widget .cancel-btn {
    background: transparent;
    color: #877d88;
    border: none;
}

.journey-contact-update-step-widget .cancel-btn:hover {
    background: #877d88;
}

.journey-contact-update-step-widget .widget-contents-container .loading-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-left: 0;
}
</style>
